import React from "react";
import { Link } from "react-router-dom";
import { AuthShell, Field, FormError, FormNotice, SubmitButton } from "@/components/AuthShell";
import { Input, Select } from "@/components/ui";
import { apiError, endpoints } from "@/lib/api";

const EMPTY = { name: "", company_name: "", role: "advisor", email: "", password: "", confirm_password: "" };

export default function Register() {
  const [f, setF] = React.useState(EMPTY);
  const [err, setErr] = React.useState("");
  const [done, setDone] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (f.password.length < 8) return setErr("Password must be at least 8 characters.");
    if (f.password !== f.confirm_password) return setErr("Passwords do not match.");
    setLoading(true);
    try {
      await endpoints.register(f);
      setDone(true);
    } catch (ex) { setErr(apiError(ex)); } finally { setLoading(false); }
  };

  if (done) {
    return (
      <AuthShell testid="register-success" eyebrow="Almost there" title="Check your inbox."
        subtitle={`We sent a verification link to ${f.email}. Verify your email to activate your workspace.`}
        footer={<Link to="/login" className="text-gold hover:underline" data-testid="register-to-login">Back to sign in</Link>}>
        <FormNotice msg="Account created. The link expires in 48 hours." />
      </AuthShell>
    );
  }

  return (
    <AuthShell testid="register-page" eyebrow="Request access" title={<>Create your <span className="italic text-gold">Clara</span> account.</>}
      subtitle="For financial advisors and M&A professionals."
      footer={<>Already have an account? <Link to="/login" className="text-gold hover:underline" data-testid="register-to-login">Sign in</Link></>}>
      <form onSubmit={submit} data-testid="register-form">
        <FormError msg={err} />
        <Field label="Full name"><Input required value={f.name} onChange={set("name")} data-testid="register-name" /></Field>
        <Field label="Company name"><Input required value={f.company_name} onChange={set("company_name")} data-testid="register-company" /></Field>
        <Field label="Role">
          <Select value={f.role} onChange={set("role")} data-testid="register-role">
            <option value="advisor">Advisor</option>
            <option value="analyst">Analyst</option>
            <option value="partner">Partner</option>
          </Select>
        </Field>
        <Field label="Email"><Input type="email" required value={f.email} onChange={set("email")} data-testid="register-email" autoComplete="email" /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Password"><Input type="password" required value={f.password} onChange={set("password")} data-testid="register-password" autoComplete="new-password" /></Field>
          <Field label="Confirm"><Input type="password" required value={f.confirm_password} onChange={set("confirm_password")} data-testid="register-confirm-password" autoComplete="new-password" /></Field>
        </div>
        <SubmitButton loading={loading} testid="register-submit">Create account</SubmitButton>
      </form>
    </AuthShell>
  );
}
